import axios from "axios";

export const getSubmittedCandidatesGridService = (queryStr) => {
    return axios.get(`api/candidatesubmission?${`$count=true&`}${queryStr}`);
};

export const getSubmittedCandidatesServiceForExcel = (queryStr) => {
    return axios.get(`api/candidatesubmission/excel?${queryStr}`);
};